module.exports = __webpack_public_path__ + "static/img/testDianpian1.9bce7c7.png";